module.exports = __webpack_public_path__ + "static/img/Six of Pentacles.9fbfd6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Six of Pentacles.jpg
// module id = 1300
// module chunks = 0